<app-model
  [dimensions]="{ width: 700, height: 750 }"
  [id]="modalId"
  [hasBackBtn]="false"
  [hasTitle]="false"
  [isNewModel]="true"
  (close)="onPopupClose()"
>
  <div modal-header class="create-role-modal-header w-100">
    <label
      class="modal-title"
      [translatable]="{
        transKey: titleTranslationKey,
        modEnum: titleTranslationModuleEnum
      }"
    >
      {{ title }}
    </label>
  </div>

  <div modal-content class="create-role-modal-content border-top">
    <div class="container new-model-dialog-body border p-0">
      <ng-container *ngIf="isGettingKPIs; else strategic_kpis">
        <ng-container [ngTemplateOutlet]="skeleton"></ng-container>
      </ng-container>
      <ng-template #strategic_kpis>
        <div class="strategic-kpis-wrapper" *ngIf="kpIs">
          <app-strategic-kpis
            [treeData]="kpIs"
            [selectedKPisIds]="selectedKPIsIds"
            [isFormSubmitted]="false"
            [readOnly]="false"
            (onSelectKPIs)="getSelectedStrategicKPIs($event)"
            (onSelect)="getSelectedStrategicKPIsIds($event)"
          ></app-strategic-kpis>
        </div>
        <div class="empty-strategic-kpis" *ngIf="kpIs?.length == 0 || !kpIs">
          <app-no-data
            [msgTranslationKey]="'shared.noDataKpis'"
            [selectedTranslationModuleEnum]="translationModulesEnum.shared"
            [msg]="'shared.noDataKpis' | translate"
          ></app-no-data>
        </div>
      </ng-template>
      <ng-template #skeleton>
        <app-skeleton-loader mode="table"></app-skeleton-loader>
        <app-skeleton-loader mode="table"></app-skeleton-loader>
        <app-skeleton-loader mode="table"></app-skeleton-loader>
        <app-skeleton-loader mode="table"></app-skeleton-loader>
      </ng-template>
    </div>
    <div class="new-model-dialog-footer">
      <!-- back button -->
      <span
        class="w-100"
        [translatable]="{
          transKey: 'shared.back',
          modEnum: translationModulesEnum.shared
        }"
      >
        <button class="btn btn-dark flex-grow-1 w-100" (click)="onPopupClose()">
          {{ "shared.back" | translate }}
        </button>
      </span>

      <!-- save button -->
      <span class="w-100">
        <button
          class="btn btn-main flex-grow-1 w-100"
          [disabled]="isGettingKPIs || selectedKPIsIds?.length == 0"
          (click)="onSave()"
        >
          <i class="bx bx-loader-alt bx-spin ml-1" *ngIf="isGettingKPIs"></i>
          {{ "shared.save" | translate }}
        </button>
      </span>
    </div>
  </div>
</app-model>
